module.exports = __webpack_public_path__ + "static/media/sprites_2x.cb4af637.png";